<template>
	<div class="form-input-root">
		<hr v-if="answerInputidx > 0"/>
		<div class="item-row">
			<div class="item-cell" v-html="infoHtml"></div>
		</div>
		<div class="item-row">
			<div class="item-cell form-display" ref="formElement"></div>
		</div>
		<div class="item-row form-input-group item-input-outline" style="margin-top:4px" v-for="(inputAnswer, i) in inputAnswerList" :key="'ia' + i">
			<div class="item-cell form-input-editor" style="flex:1;">
				<div class="eq-editor" ref="inputElements" @focus="editFocused" @input="editChanged" :contenteditable="mode == 'ANSWER'" placeholder="정답 입력"></div>
			</div>
			<div class="item-cell" style="width:44px;">
				<button class="button button-fill" :disabled="mode != 'ANSWER'" v-on:click="editEquationBtnClick"><i class="f7-icons">function</i></button>
			</div>
		</div>
		<div v-if="mode == 'SCORE'">
			<span class="text-color-purple">정답 : </span><br/>
			<p v-for="(answer, i) in answerList" :key="'i' + i" style="margin:0;">
				{{i+1}} : <span v-html="convertEquation(answer)"></span>
			</p>
		</div>
	</div>
</template>

<script>
	import MODULE from '../../js/common/module';
	import store from '../../js/store';
	import MathLive from 'mathlive';

	export default {
		props: {
			examNo: { default: 0 },
			subExamIdx: { default: 0 },
			answerInputidx: { default: 0 },
		},
    data() {
      return {
				infoHtml: "",
				formHtml: "",
      }
		},
		computed: {
			mode() {
				return this.getCommonObj().mode;
			},
			info() {
				return this.getAnswerInput().info;
			},
			form() {
				return this.getAnswerInput().form;
			},
			answerList() {
				return this.getAnswerInput().answerList;
			},
			inputAnswerList() {
				return this.getAnswerInput().inputAnswerList;
			}
		},
		mounted() {
			this.renderInfo();
			this.renderForm();
			this.renderInputAnswer();
		},
    methods: {
			getCommonObj() {
				return store.getters.commonObj;
			},
			getAnswerInput() {
				var answers = this.getCommonObj().answers;

				var examIndex = this.examNo - 1;
				var exam = answers[examIndex];
				var subExam = exam.subExamList[this.subExamIdx];
				var answerInput = subExam.answerInputList[this.answerInputidx];

				return answerInput;
			},
			renderInfo() {
				let html = this.info;
				if (MODULE.Util.isEmpty(html)) {
				this.infoHtml = "빈칸형 답안"
			} else {
				this.infoHtml = MODULE.UITool.convertEquationHTML(html);
			}
			},
			renderForm() {
				var formElement = $(this.$refs.formElement);

				formElement.html(this.form);
				this.convertToEquationDisplay(formElement);
			},
			renderInputAnswer() {
				var _this = this;

				var inputElements = _this.$refs.inputElements;

				for (let i=0; i<this.inputAnswerList.length; i++) {
					let inputAnswer = _this.inputAnswerList[i];

					let inputElement = $(inputElements[i]);
					inputElement.html(inputAnswer);
					_this.convertToEquationEditor(inputElement);
				}
			},
			convertEquation(equation) {
				let html = equation;
				return MODULE.UITool.convertEquationHTML(html);
			},
			editFocused(e) {
				if (this.mode != "ANSWER") {
					return;
				}

				const element = $(e.currentTarget);
				const formInputRoot = element.closest(".form-input-root");
				const formInputGroup = element.closest(".form-input-group");
				
				// 선택된 elements 중에서 지정된 element의 index를 구해옴.
				const index = formInputRoot.find(".form-input-group").index(formInputGroup);

				this.activeFormBox(formInputRoot, index);
			},
			editChanged(e) {
				const editor = $(e.currentTarget);
				const formInputGroup = editor.closest(".form-input-group");
				const index = formInputGroup.index();

				const answer = MODULE.UITool.recursiveGetTextContents(editor[0]);

				const inputAnswerList = this.inputAnswerList;
				inputAnswerList[index] = answer;
			},
			editEquationBtnClick(e) {
				const element = $(e.currentTarget);
				const formInputGroup = element.closest(".form-input-group");
				const editor = formInputGroup.find("div.eq-editor");

				const index = formInputGroup.index();
				const formInputRoot = element.closest(".form-input-root");
				this.activeFormBox(formInputRoot, index);

				this.editEquation(editor, undefined);
			},
			openEquationDialog(equation) {
				var def = jQuery.Deferred();

				const eqDialog = $("#equation-popup");
				eqDialog.off("popup:closed").on("popup:closed", function(e) {
					var equation = eqDialog.data("equation");
					
					def.resolve(equation);
				});

				eqDialog.data("equation", equation);

				this.$f7.popup.open("#equation-popup", true);

				return def.promise();
			},
			convertToEquationDisplay(div) {
				var _this = this;

				var html = div.html();

				var eqReplacer = function (match) {
					var subHtml = match;
					var subDiv = $("<div>" + subHtml + "</div>");
					MathLive.renderMathInElement(subDiv[0]);

					return subDiv.html();
				}

				html = html.replace(/\$\$.+\$\$/g, eqReplacer);

				// 스페이스 유니코드 특수문자 0x3000 공백 문자를 사용하였음.
				html = html.replace(/##FORM-BOX##/g, '<span class="form-box" contenteditable="false">　</span>');

				div.html(html);

				div.find("span.sr-only").remove();

				div.find(".ML__mathlive").prop("contenteditable", false);

				div.find(".ML__mathlive").css({
					"border": "1px solid #ccc",
					"padding": "4px 2px 2px 2px",
					"margin": "2px 2px",
					"font-size": "1.8rem",
					"font-size": "18px",
					"user-select": "none",
					"vertical-align": "middle"
				});

				div.find('.ML__ams[style*="color:"], .form-box').ev("click", function(e) {
					var element = $(this);
					var formDisplay = element.closest(".form-display");
					var formBoxList = formDisplay.find('.ML__ams[style*="color:"], .form-box');
					var formActiveIndex = formBoxList.index(element);
					var formInputRoot = element.closest(".form-input-root");

					_this.activeFormBox(formInputRoot, formActiveIndex);
				});
			},
			convertToEquationEditor(div) {
				var _this = this;

				var html = div.html();

				var eqReplacer = function (match) {
					var subHtml = match;
					var subDiv = $("<div>" + subHtml + "</div>");
					MathLive.renderMathInElement(subDiv[0]);

					return subDiv.html();
				}

				html = html.replace(/\$\$.+\$\$/g, eqReplacer);

				// 스페이스 유니코드 특수문자 0x3000 공백 문자를 사용하였음.
				html = html.replace(/##FORM-BOX##/g, '<span class="form-box" contenteditable="false">　</span>');

				div.html(html);

				div.find("span.sr-only").remove();

				div.find(".ML__mathlive").prop("contenteditable", false);
				div.find(".ML__mathlive").ev("mousedown", function (e) {
					var element = $(this);

					var editorGroup = element.closest(".math-editor");
					var eqRootSpan = element.closest("span[data-original-content]");
					_this.editEquation(editorGroup, eqRootSpan);
				});

				div.find(".ML__mathlive").css({
					"border": "1px solid #ccc",
					"padding": "4px 2px 2px 2px",
					"margin": "2px 2px",
					"font-size": "1.8rem",
					"font-size": "18px",
					"cursor": "pointer",
					"user-select": "none",
					"vertical-align": "middle"
				});
			},
			activeFormBox: function (formInputRoot, formActiveIndex) {
				var _this = this;

				var formDisplay = formInputRoot.find(".form-display");
				var formBoxList = formDisplay.find('.ML__ams[style*="color:"], .form-box');
				var formBox = formBoxList.eq(formActiveIndex);

				formBoxList.removeClass("selected");
				formBox.addClass("selected");

				var editors = formInputRoot.find('.eq-editor');
				var editor = editors.eq(formActiveIndex);

				editors.removeClass("selected");
				editor.addClass("selected");

				if (! editor.is(":focus")) {
					editor.focus();
				}
			},
			editEquation: function(editor, eqRootSpan) {
				var _this = this;

				// mousedown후 바로 editor.focus 불가능
				// 비동기로 다음 이벤트로 넘겨야 focus가 정상 작동함.
				MODULE.UITool.asyncRun(function () {
					editor.focus();
					MODULE.UITool.saveCaretPosition(editor);
				}).then(function (data) {
					var equation = " ";	// must space. NOT empty("") !!
					if (eqRootSpan != undefined) {
						equation = eqRootSpan.data("original-content");
					}

					return _this.openEquationDialog(equation);
				}).then(function (data) {
					if (data != undefined && data != "") {
						var equation = data;
						var html = "<div>$$" + equation + "$$</div>";
						
						var div = $(html);
						_this.convertToEquationEditor(div);

						editor.focus();
						MODULE.UITool.restoreCaretPosition(editor);

						if (eqRootSpan != undefined) {
							var jqueryElement = div.find("span[data-original-content]");
							
							eqRootSpan.replaceWith(jqueryElement);
						} else {
							/*
							var element = $("<span>&zwnj;</span>");
							element = element[0];
							_this.insertElementAtCaret(element);
							*/

							var element = div.find("span[data-original-content]");
							element = element[0];
							_this.insertElementAtCaret(element);

							/*
							var element = $("<span>&zwnj;</span>");
							element = element[0];
							_this.insertElementAtCaret(element);
							*/
						}

						var html = editor.html();
						editor.data("before", html);
						editor.trigger("change");
						editor.trigger("special-change");

						MODULE.UITool.asyncRun(function () {
							editor.focus();
						});
					} else {
						editor.focus();
						MODULE.UITool.restoreCaretPosition(editor);
					}
				}).catch(function (code) {
					editor.focus();
					MODULE.UITool.restoreCaretPosition(editor);
				});
			},
      insertElementAtCaret: function (element) {
				var _this = this;

				var sel, range;
				if (window.getSelection) {
					// IE9 and non-IE
					sel = window.getSelection();
					if (sel.getRangeAt && sel.rangeCount) {
						range = sel.getRangeAt(0);
						range.deleteContents();
						range.insertNode(element);

						range.setStartAfter(element);
						range.setEndAfter(element);
						range.collapse(true);

						sel.removeAllRanges();
						sel.addRange(range);
					}
				} else if ((sel = window.selection) && sel.type != "Control") {
					// IE < 9
					var originalRange = sel.createRange();
					originalRange.collapse(true);
					sel.createRange().pasteHTML(html);
				}
			},

    }
  }

</script>